/** Logistikunternehmen-ID für TrackCode (interne Nutzer). */
export const TRACKCODE_LOGISTIC_COMPANY_ID = 7;

export const isTrackCodeInternalUser = user =>
  user?.logisticcompany_id === TRACKCODE_LOGISTIC_COMPANY_ID;
